import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claimGroup/${COMMON_QUERY_PARAMS.CLAIM_GROUP_ID}/user/metadata`;

interface SetUserMetadataCommandArgs {
  claimGroupId: string;
  visitorId: string;
  visitorData: string;
}

export const setUserMetadataCommand = async ({
  claimGroupId,
  visitorId,
  visitorData,
}: SetUserMetadataCommandArgs): Promise<
  BackResponse<void> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<void>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_GROUP_ID, claimGroupId),
      {
        method: SUPPORTED_METHODS.POST,
        json: {
          visitorId,
          data: visitorData,
        },
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
